<style src="./CardView.scss" lang="scss"></style>

<template lang="pug">
  .card-view(
    :class='classList'
    v-click-outside='deTouch'
  )
    .card-view__box
      .card-view__cover
        .card-view__heart(
          v-if='type === "favorites"'
        )
          Icon(
            name='heartFilled'
          )

        Cover(
          v-if='type !== "favorites"'
          :type='type'
          :cover='cover'
        )

      button.card-view__delete(
        v-if='removable && !checked'
        @click='$emit("delete")'
        :title='$l10n("REMOVE")'
        type='button'
      )
        Icon(
          name='delete'
        )

      button.card-view__restore(
        v-if='removable && checked'
        @click='$emit("restore")'
        :title='$l10n("RESTORE")'
        type='button'
      )
        Icon(
          name='restore'
        )

      .card-view__likes(
        v-if='likes'
      )
        Like(
          v-if='active'
          :liked='likes.liked'
          :count='likes.count'
          :color='type === "artist" ? "white" : null'
          @like='$emit("like")'
          @unlike='$emit("unlike")'
        )
          
      .card-view__controls(
        v-if='showControls && active'
      )
        .card-view__play-button(
          @click='$emit("play")'
          v-if='!running'
        )
          ControlButton(
            type='play'
            icon='play'
          )
        .card-view__play-button(
          @click='$emit("pause")'
          v-else
        )
          ControlButton(
            type='pause'
            icon='pause'
          )
        .card-view__context-menu(
          v-if='contextMenu'
        )
          ContextMenu(
            :list='contextMenu'
          )
    .card-view__headline
      router-link.card-view__name(
        event=''
        :to='link'
        :title='title'
        @click.native.prevent='clickHandler'
      ) {{ title }}
      .card-view__artists(
        v-if='artists.length'
      )
        router-link.card-view__artist(
          v-if='artist.id && active'
          v-for='artist in artists'
          :key='artist.id'
          :to='`/artists/${artist.id}`'
        ) {{ artist.name }}
        span.card-view__artist(
          v-else
          v-for='artist in artists'
          :key='artist.id'
        ) {{ artist.name }}
</template>
<script>
import Cover from "@/components/Cover/Cover";
import Icon from "@/components/Icon/Icon";
import ControlButton from "@/components/ControlButton/ControlButton";
import ContextMenu from "@/components/ContextMenu/ContextMenu";
import Like from "@/components/Like/Like";

import { BREAKPOINS } from "@/constants";

const allowedTypes = [
  "track",
  "album",
  "artist",
  "genre",
  "playlist",
  "favorites"
];

export default {
  name: "CardView",
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      validator(value) {
        return allowedTypes.includes(value);
      }
    },
    id: String,
    title: String,
    link: String,
    likes: Object,
    cover: [Object, Array],
    artists: {
      type: Array,
      default: () => []
    },
    showControls: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: true
    },
    running: Boolean,
    loading: Boolean,
    checked: Boolean,
    removable: Boolean,
    contextMenu: Array
  },
  data() {
    return {
      touched: false
    };
  },
  components: {
    Cover,
    Like,
    Icon,
    ControlButton,
    ContextMenu
  },
  computed: {
    classList() {
      return {
        [`is-${this.type}`]: true,
        "is-loading": this.loading,
        "is-removed": this.checked,
        "is-touched": this.touched
      };
    }
  },
  methods: {
    clickHandler() {
      const windowWidth = window.innerWidth;
      const isDesktop = BREAKPOINS.m < windowWidth;

      if (!isDesktop && !this.touched && this.type !== "genre") {
        this.touched = true;
      } else {
        this.$router.push(this.link);
      }
    },
    deTouch() {
      this.touched = false;
    }
  }
};
</script>
